<template>
  <div>
    <TopBanner />
    <div class="row top">
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link to="/ehon.html">
          <img src="/static/images/top/ehon.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="えほんへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/taiken.html">
          <img src="/static/images/top/taiken.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="体験する絵本展と読み聞かせなどページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/dance.html">
          <img src="/static/images/top/dance.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="タネタネダンスページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/campaign.html">
          <img src="/static/images/top/harukaze.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="ふしぎなプレゼントキャンペーンページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/donguri.html">
          <img src="/static/images/top/donguri.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="どんぐり通貨ページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/yomikikasetai.html">
          <img src="/static/images/top/yomikikase.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="よみきかせ隊がいきます！ページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <a href="https://okaimono.ohisamak-ehonya.com" target="_blank">
          <img src="/static/images/top/okaimono.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="おかいものページへのリンク画像" class="img-fluid change-image">
        </a>
      </div>
      <div class="col-md-12 col-lg-6 text-center m-auto">
        <router-link  to="/houkoku.html">
          <img src="/static/images/top/houkokutai.png" v-on:mouseover="changeImg" v-on:mouseleave="returnImg" alt="つくったよ報告隊!ページへのリンク画像" class="img-fluid change-image">
        </router-link>
      </div>
      <div class="col-md-12 text-center map">
        <router-link  to="/world.html">
          <img src="/static/images/top/sekai.png" alt="" class="img-fluid change-image" v-on:mouseover="changeImg" v-on:mouseleave="returnImg">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import TopBanner from './TopBanner.vue'

export default {
  title: 'トップページ',
  name: 'top',
  components: {
    TopBanner
  },
  methods: {
    changeImg: function(e) {
      if (screen.width >= 750) {
        var imgUrl = e.target.getAttribute("src");
        var imgUrl = imgUrl.replace(/\/(.*)\.png/g,"/$1_on.png");
        e.target.setAttribute("src", imgUrl)
      }
    },
    returnImg: function(e) {
      if (screen.width >= 750) {
        var imgUrl = e.target.getAttribute("src");
        var imgUrl = imgUrl.replace(/\/(.*)_on\.png/g,"/$1.png");
        e.target.setAttribute("src", imgUrl)
      }
    }
  },
  mounted: function() {
    this.$nextTick(function () {
      try {
        FONTPLUS.reload();
      } catch (error) {
        console.log(error.message);
      }

      if (screen.width < 750) {
        document.querySelectorAll('.change-image').forEach( img => {
          var imgUrl = img.getAttribute("src");
          var imgUrl = imgUrl.replace(/\/(.*)\.png/g,"/$1_on.png");
          img.setAttribute("src", imgUrl)
        });
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Top.vue